import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import type { AdminRole } from '../lib/admin-roles'

// Defense-in-depth route guard for the admin portal. The sidebar in
// Layout.tsx already filters menu entries by role, but typing a
// privileged URL directly (e.g. /dispatch as a marketing admin) would
// otherwise load the page and silently 403 every API call, leaving the
// user staring at a broken-looking blank screen.
//
// Wrapping a Route with <RoleGuard roles={...}> redirects the user to
// /dashboard if their current role isn't in the allowed list. /dashboard
// is the universally accessible landing page (roles: ALL in the sidebar).
//
// Server-side enforcement is still the source of truth via the
// requireRole(...) middleware in backend/worker/src/lib/middleware.ts.
// This guard is a UX layer, not a security boundary.
export function RoleGuard({
  roles,
  children,
}: {
  roles: AdminRole[]
  children: React.ReactNode
}) {
  const { can } = useAuth()
  if (!can(roles)) return <Navigate to="/dashboard" replace />
  return <>{children}</>
}
